import { render } from "./Detailed.vue?vue&type=template&id=78e6d02b&scoped=true"
import script from "./Detailed.vue?vue&type=script&lang=js"
export * from "./Detailed.vue?vue&type=script&lang=js"

import "./Detailed.vue?vue&type=style&index=0&id=78e6d02b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e6d02b"]])

export default __exports__